export const STATUS_OPTIONS = [
  { value: '', label: 'Any status' },
  { value: 'complete', label: 'Complete' },
  { value: 'pending', label: 'Pending' },
  { value: 'incomplete', label: 'Incomplete' },
];

export function defaultTrustedCircleFilters() {
  return {
    state: '',
    status: '',
    addedBySearch: '',
    contactSearch: '',
  };
}

export function toListParams(filters, page, limit) {
  const params = { page, limit };
  if (filters.state) params.state = filters.state;
  if (filters.status) params.status = filters.status;
  if (filters.addedBySearch?.trim()) params.addedBy = filters.addedBySearch.trim();
  if (filters.contactSearch?.trim()) params.search = filters.contactSearch.trim();
  return params;
}

export function statusLabel(dbStatus) {
  if (!dbStatus) return 'Incomplete';
  const s = String(dbStatus).toLowerCase();
  const map = { complete: 'Complete', pending: 'Pending', incomplete: 'Incomplete' };
  return map[s] || dbStatus;
}

export function statusClass(dbStatus) {
  const s = String(dbStatus || '').toLowerCase();
  const map = {
    complete: 'tc-status tc-status-complete',
    pending: 'tc-status tc-status-pending',
    incomplete: 'tc-status tc-status-incomplete',
    accepted: 'tc-status tc-status-complete',
    invited: 'tc-status tc-status-pending',
    declined: 'tc-status tc-status-incomplete',
    blocked: 'tc-status tc-status-incomplete',
  };
  return map[s] || 'tc-status';
}

/** UI role label → API enum (primary | member | admin). */
export function mapRoleToApi(uiRole) {
  const raw = String(uiRole || '').trim().toLowerCase();
  if (raw === 'admin' || raw === 'co-owner') return 'admin';
  if (raw === 'primary') return 'primary';
  return 'member';
}

export function mapRoleToLabel(apiRole) {
  const raw = String(apiRole || '').toLowerCase();
  if (raw === 'admin') return 'Admin';
  if (raw === 'primary') return 'Primary';
  return 'Member';
}

export function reminderToastMessage(data) {
  const sent = data?.sentCount ?? 0;
  const skipped = data?.skippedCount ?? 0;
  if (sent === 0 && skipped === 0) return 'No pending members to remind';
  return `Reminders sent: ${sent}${skipped ? `, skipped: ${skipped}` : ''}`;
}

export function formatContactDate(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
